import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class CalendarIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fillRule="evenodd" d="M5 2h6V0h2v2h2a1 1 0 0 1 1 1v2H0V3a1 1 0 0 1 1-1h2V0h2v2zM0 6h16v6l-4 4H1a1 1 0 0 1-1-1V6zm11 9l4-4h-4v4z"/></svg>
        )
    }
}

export default withCssClassName(CalendarIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/calendar-icon.js